export default function productPage() {
  const selectors = {
    productPage: '.template-product',
    main: '[data-product-main]',
    accordions: '[data-accordion]',
    addToCartContainer: '[data-add-to-cart-container]',
  }

  const productPageElement = document.querySelector(selectors.productPage);
  const mainElement = document.querySelector(selectors.main);
  const accordionElements = document.querySelectorAll(selectors.accordions);
  const addToCartContainerElement = document.querySelector(selectors.addToCartContainer);

  const cloneProductPageAccordion = () => {
    accordionElements.forEach((accordion: HTMLElement) => {
      const cloneAccordionContent: any = accordion.cloneNode(true);
      const cloneAccordionMain: any = accordion.cloneNode(true);
      cloneAccordionContent.classList.add('pt-14');
      addToCartContainerElement.after(cloneAccordionContent);
      cloneAccordionMain.classList.remove('lg:hidden');
      cloneAccordionMain.classList.add('hidden', 'lg:block');
      mainElement.append(cloneAccordionMain);
      accordion.remove();
    });
  }

  if (accordionElements.length > 0 && productPageElement) {
    cloneProductPageAccordion();
  }
}

productPage();
